export const INTERRUPTED_TOOL_ERROR =
  'Tool preparation or execution ended before a result was received.';

type FinalizableToolStatus = {
  status: 'preparing' | 'calling' | 'done' | 'error';
  error?: string;
  resultState?:
    | 'ok'
    | 'no_results'
    | 'coverage_gap'
    | 'fallback_used'
    | 'timeout_or_cancelled'
    | 'error';
  failureKind?:
    | 'timeout_or_cancelled'
    | 'query_error'
    | 'validation_error'
    | 'rate_limit'
    | 'auth_error'
    | 'not_found'
    | 'conflict'
    | 'transient_error'
    | 'permanent_error';
};

export function isPendingToolStatus(
  status: FinalizableToolStatus['status']
): status is 'preparing' | 'calling' {
  return status === 'preparing' || status === 'calling';
}

/**
 * Pending is a live-only state. Persisted or terminal traces without a result
 * are interruptions, including rows written by revisions that predate this
 * invariant. This makes old sessions self-healing on hydration without a data
 * migration.
 */
export function finalizePendingToolStatus<T extends FinalizableToolStatus>(tool: T): T {
  if (!isPendingToolStatus(tool.status)) return tool;
  return {
    ...tool,
    status: 'error',
    error: INTERRUPTED_TOOL_ERROR,
    resultState: 'error',
    failureKind: 'timeout_or_cancelled',
  } as T;
}
